import React, { useState, useEffect, useMemo } from 'react';
import countdown from 'countdown';
import { makeStyles } from '@material-ui/core/styles';

import CourseWork from '../../models/CourseWork';
import utils from '../../libs/utils';

export interface ExamCountdownProps {
  courseWork?: CourseWork;
}

const useStyles = makeStyles((theme) => ({
  buttonsContainer: {
    display: 'flex',
  },
}));

export const ExamCountdown = (props: ExamCountdownProps) => {
  const classes = useStyles();
  const { courseWork } = props;
  const [currentTime, setCurrentTime] = useState<number>(Date.now());
  
  let countdownInterval: NodeJS.Timeout;
  const startCurrentTimeInterval = () =>
  setInterval(() => {
    setCurrentTime((_currentTime) => Date.now());
    
    if (utils.hasExamEnded(courseWork)) clearInterval(countdownInterval);
    }, 1000);

  useEffect(() => {
    if (courseWork && courseWork.dueDate) countdownInterval = startCurrentTimeInterval();
  }, []);

  const timeRemainingTillDue = useMemo(
    () =>
      countdown(currentTime, utils.getExamDueUnix(courseWork)).toString() ||
      '0',
    [currentTime]
  );

  if (!courseWork || courseWork.name !== 'Exam' || !courseWork.dueDate) {
    return null;
  }

  return (
    <>
      <div>
        <h4 className={classes.buttonsContainer}>
          Due Date: {utils.getFormattedExamDue(courseWork)} UTC
        </h4>
      </div>
      <div>
        <h5 className={classes.buttonsContainer}>
          {utils.hasExamEnded(courseWork)
            ? 'Exam Ended'
            : `Time Remaining: ${timeRemainingTillDue}`}
        </h5>
      </div>
    </>
  );
};
